/**
 * Layout-only parent route for /contacts/*.
 * See `_app.deals.tsx` for the rationale.
 */
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/contacts")({
  component: ContactsLayout,
});

function ContactsLayout() {
  return <Outlet />;
}
